import React, { useMemo } from 'react';
import { useTextWithBreaksContext, VARIANT as TEXT_BREAK_VARIANT } from './index';
import { getColoredText, getPrefixes, removePrefixes } from './utils';
import TitleBreak from './TitleBreak';
import { CURSOR_TYPES, ICONS } from '@repo/utils/constants';
import { TEXT_VARIANTS } from '../Text';
import WebGLText from '../../WebGL/Text/Text';
import { isFunction } from '@repo/utils';
import HiddenPill from './Static/HiddenPill';
import { HOVER_VARIANTS } from './Classic/Row';


function getUIndex(matrix, rowIndex, colIndex) {
    let finalIndex = 0;

    // Sum the lengths of all previous rows
    for (let i = 0; i < rowIndex; i++) {
        finalIndex += matrix[i].length;
    }

    // Add the column index inside the target row
    finalIndex += colIndex;

    return finalIndex;
}

const Paragraph = ({
       index,
       text,
       hover='',
       onClick,
       onPointerLeave,
       onPointerEnter,
       imageLoadPriority = false,
       left,
       breakId = '',
       rowIndex=0,
       ...props
}) => {
    const exist  = text.length > 0
    const webGL = useTextWithBreaksContext('webGL')
    const breaks = useTextWithBreaksContext('breaks')
    const color = useTextWithBreaksContext('color')
    const variant = useTextWithBreaksContext('variant')
    const rows = useTextWithBreaksContext('formatted')
    const { isBreak, isActive, isHidden } = getPrefixes(text)
    const breakHover = isActive ? (variant === TEXT_BREAK_VARIANT.STATIC ? HOVER_VARIANTS.HOVER : HOVER_VARIANTS.CLICKED) : hover
    const uniqueIndex = useMemo(() => getUIndex(rows,rowIndex,index + 2), [rows, index, rowIndex])

    const image = useMemo(() => {
        let source
        if(breakId){
            source = breaks.data.find((item) => item.id === breakId)
        } else {
            const titleBreakIndex = breaks.texts.findIndex((el) =>  el.text.includes(text))
            source = breaks.data[titleBreakIndex]
        }
        // console.log(source);
        return source?.image || { url:'' , alt: '' };

    },[text, breaks])
    const { color: specifiedColor, text: coloredText } = getColoredText(text)
    const breakText = removePrefixes(text)

    if(!exist) return null


    return isBreak ? (
        <TitleBreak
            icon={ICONS.WAVE}
            image={image}
            hover={breakHover}
            color={specifiedColor || color}
            variant={TEXT_VARIANTS.ITALIC}
            noCursorHover={isHidden}
            onPointerLeave={() => {
                if(isActive || isHidden || !isFunction(onPointerLeave)) return
                onPointerLeave(index)
            }}
            onPointerEnter={() => {
                if(isActive || isHidden || !isFunction(onPointerEnter)) return
                onPointerEnter(index)
            }}
            webGL={webGL}
            left={left}
            imageLoadPriority={imageLoadPriority}
            onClick={() => {
                if(isActive || isHidden || !isFunction(onClick)) return
                onClick(index)
            }}
            uIndex={uniqueIndex}
            {...props}
        >
            {isHidden ? <HiddenPill text={breakText}/> : breakText}
        </TitleBreak>
    ) : (
        <WebGLText
            hover={Boolean(hover)}
            data-cursor={webGL ? CURSOR_TYPES.TEXT3D : null}
            color={specifiedColor || color}
            show3D={webGL}
            uIndex={uniqueIndex}
            {...props}
        >
            {coloredText}
        </WebGLText>
    )
}


export default Paragraph;
